import { cn } from '../lib/cn.js'

/**
 * Radio e checkbox com área de toque de 44px e preço à direita — é o formato
 * dos adicionais ("Bacon extra  + R$ 5,00"). O input nativo fica, para o
 * teclado e o leitor de tela funcionarem sem gambiarra de ARIA.
 */
export type EscolhaProps = {
  tipo: 'radio' | 'checkbox'
  nome: string
  valor: string
  rotulo: string
  descricao?: string | undefined
  precoExtra?: string | undefined
  marcada?: boolean | undefined
  desabilitada?: boolean | undefined
  esgotada?: boolean | undefined
  onMudar?: (marcada: boolean) => void | undefined
  className?: string | undefined
}

export function Escolha({
  tipo, nome, valor, rotulo, descricao, precoExtra,
  marcada, desabilitada, esgotada, onMudar, className,
}: EscolhaProps) {
  const bloqueada = desabilitada || esgotada
  return (
    <label className={cn('du-escolha', bloqueada && 'du-escolha--bloqueada', className)}>
      <input
        type={tipo}
        name={nome}
        value={valor}
        checked={marcada}
        disabled={bloqueada}
        onChange={(e) => onMudar?.(e.target.checked)}
      />
      <span className="du-escolha__marca" aria-hidden />
      <span className="du-escolha__corpo">
        <span className="du-escolha__rotulo">
          {rotulo}
          {esgotada ? <span className="du-escolha__esgotado">esgotado</span> : null}
        </span>
        {descricao ? <span className="du-escolha__descricao">{descricao}</span> : null}
      </span>
      {precoExtra ? <span className="du-escolha__preco">{precoExtra}</span> : null}
    </label>
  )
}
